<template>
    <div ref="disableTwoFactorBlock" class="row">
        <div class="col-sm-12 mb-3" >
            <div class="d-flex flex-column gap-3 text-center align-items-center">
	            <i class="bi w-auto h-auto fs-large bi-shield-fill-minus"></i>
                <h3 class="fw-semi-bold m-0">Disable Two Factor Authentication</h3>
                <p class="text-secondary m-0">Are you sure you want to disable two factor authentication using Authenticator App.</p>
            </div>
        </div>

        <div class="col-12">
            <div class="d-flex flex-row align-items-center justify-content-center gap-3 text-center ">
                <button class="btn btn-outline-secondary rounded-pill py-2 px-3" @click="close">Cancel</button>
                <button class="btn btn-dark rounded-pill py-2 px-3" @click="disableTwoFactor">Disable</button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { watch, ref } from "vue";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import { useAuthStore } from "@/stores/auth-store.js";
import { useToast } from "@/composables/useToast.js";

const emits = defineEmits(['closeDisableTwoFactor']);

const auth = useAuthStore();
const helper = useAppHelpers();
const { displayToast } = useToast();

const disableTwoFactorBlock = ref(null);

const user = ref(auth.user);
watch(() => auth.user, (newVal) => {
	user.value = newVal;
});

const disableTwoFactor = async () => {
	try{
		helper.loaderOn(disableTwoFactorBlock.value);
		const response = await auth.disableTwoFactor();
		await close();
		helper.loaderOff(disableTwoFactorBlock.value);
	}
	catch (error) {
		helper.loaderOff(disableTwoFactorBlock.value);
	}
}

const close = async () => {
	emits('closeDisableTwoFactor');
}

defineExpose({
    close
});
</script>
